'use client'

import { Slider } from '@/components/v2/atoms/slider/slider'
import s from './banner-card-naviagtion-slider.module.css'
import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'
import { BannerCard as BannerCardType } from '@/types/api/ui-placement'
import { BannerCard } from '@/components/v2/atoms/banner-card/banner-card'
import { CSS_BREAKPOINTS_V2 } from '@/constants'

type Props = {
  bannerCards?: BannerCardType[]
}

export const BannerCardNavigationSlider = ({ bannerCards }: Props) => {
  if (!bannerCards?.length) {
    return null
  }

  return (
    <div className={s.container}>
      <Slider
        className={s.slider}
        ignoreDefaultBreakpoints
        options={{
          slides: {
            perView: 'auto',
            spacing: 16,
            origin: 0.045,
          },
          breakpoints: {
            [`(min-width: ${CSS_BREAKPOINTS_V2.tablet})`]: {
              slides: {
                perView: 'auto',
                spacing: 16,
                origin: 0.065,
              },
            },
            [`(min-width: ${CSS_BREAKPOINTS_V2.desktopS})`]: {
              slides: {
                perView: 1,
                spacing: 16,
                origin: 0,
              },
            },
          },
        }}
        renderNavigation={(slideLeft, slideRight) => {
          const navigationVisible = bannerCards.length > 1
          return (
            <div className={s.topWrapper}>
              <span className={s.title}>Explore More</span>
              {navigationVisible && (
                <div className={s.sliderControls}>
                  <button
                    onClick={slideLeft}
                    className={s.sliderArrow}
                    aria-label="Previous slide"
                  >
                    <ArrowRight
                      iconColor="#131313"
                      svgProps={{
                        style: {
                          transform: 'rotate(180deg) translateY(-1.5px)',
                        },
                      }}
                    />
                  </button>
                  <button
                    onClick={slideRight}
                    className={s.sliderArrow}
                    aria-label="Next slide"
                  >
                    <ArrowRight
                      iconColor="#131313"
                      svgProps={{
                        style: {
                          transform: 'translateY(1.5px)',
                        },
                      }}
                    />
                  </button>
                </div>
              )}
            </div>
          )
        }}
      >
        {bannerCards.map((bc) => {
          return (
            <div className={s.cardContainer} key={bc.id}>
              <BannerCard
                title={bc.title}
                buttonLink={bc.button_link}
                buttonText={bc.button_text}
                imageUrl={bc.image.url}
                imageAlt={bc.image.alt}
                adjustToSlider
                key={bc.id}
              />
            </div>
          )
        })}
      </Slider>
    </div>
  )
}
